import React from 'react';
import { Steps as AntdSteps } from 'antd';

import { IStepsProps } from './Steps.types';

import './Steps.styles.scss';

const Steps = ({ className = '', ...props }: IStepsProps) => {
  return <AntdSteps className={`np-steps ${className}`} {...props} />;
};

export default Steps;
